import { useCurrentBilikPerson } from 'hooks/use-current-bilik-person/use-current-bilik-person';
import React, { FunctionComponent, useCallback } from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { ToastError } from 'utils';
import { useReviewLocker } from '../hooks/useReviewLocker';

type ToggleLockReviewButtonProps = {
  reviewId: number;
  onComplete?: () => void;
  disabled?: boolean;
};

const ToggleLockReviewButton: FunctionComponent<
  ToggleLockReviewButtonProps
> = ({ reviewId, onComplete, disabled }) => {
  const { currentBilikPerson } = useCurrentBilikPerson();

  const { locker, isLocked, lock, unlock, loading } = useReviewLocker(reviewId);

  const handleClick = useCallback(async () => {
    if (!currentBilikPerson?.id) {
      ToastError('Erreur', "Impossible de verrouiller l'avis");
      throw new Error("Impossible de verrouiller l'avis");
    }

    if (!isLocked) {
      await lock(currentBilikPerson?.id);
    }

    if (isLocked) {
      await unlock();
    }

    onComplete?.();
  }, [currentBilikPerson, isLocked, lock, unlock, onComplete]);

  const isLockedByOtherPerson =
    !!locker && locker.id !== currentBilikPerson?.id;

  return (
    <Popup
      content={
        isLockedByOtherPerson
          ? `Avis verrouillé par ${locker.givenName} ${locker.familyName}`
          : isLocked
            ? "Déverrouiller l'avis"
            : "Verrouiller l'avis"
      }
      position="top center"
      trigger={
        <span>
          <Button
            disabled={disabled}
            loading={loading}
            onClick={handleClick}
            icon
            basic
            color="grey"
          >
            <Icon name={isLocked ? 'unlock' : 'lock'} />
          </Button>
        </span>
      }
    />
  );
};

export default ToggleLockReviewButton;
